<div class="position-relative">
  <!-- Password strength badge before the eye icon -->
  @if (showStrength && passwordStrength) {
    <span
      class="position-absolute top-50 translate-middle-y"
      style="inset-inline-end: 44px"
      [ngClass]="{
        'text-success': passwordStrength === 'strong',
        'text-danger': passwordStrength === 'weak',
        small: true,
      }"
    >
      {{ passwordStrength === 'strong' ? 'قوية' : 'ضعيفة' }}
    </span>
  }
  <input
    nz-input
    [nzSize]="nzSize"
    [class]="'bg-transparent ' + inputClass"
    [placeholder]="placeholder"
    [type]="showPassword ? 'text' : 'password'"
    [value]="value"
    [disabled]="disabled"
    (input)="onInput($event)"
    (blur)="onBlur()"
  />
  <span
    class="position-absolute top-50 translate-middle-y cursor-pointer text-gray-600"
    style="inset-inline-end: 12px"
    (click)="showPassword = !showPassword"
  >
    <i
      [class]="'fs-0_875rem ' + (showPassword ? 'aya-eye-closed' : 'aya-eye-o')"
    ></i>
  </span>
</div>

@if (showValidations) {
  <div class="mt-2">
    <div class="d-flex align-items-center gap-2 mb-1">
      @if (passwordLength) {
        <i class="isax isax-tick-circle text-success"></i>
      } @else {
        <i class="isax isax-record-circle text-gray-600"></i>
      }
      <small
        [class.text-success]="passwordLength"
        [class.text-gray-600]="!passwordLength"
      >
        {{ 'SHARED.PASSWORD.MIN_LENGTH' | translate }}
      </small>
    </div>
    <div class="d-flex align-items-center gap-2">
      @if (passwordComplexity) {
        <i class="isax isax-tick-circle text-success"></i>
      } @else {
        <i class="isax isax-record-circle text-gray-600"></i>
      }
      <small
        [class.text-success]="passwordComplexity"
        [class.text-gray-600]="!passwordComplexity"
      >
        {{ 'SHARED.PASSWORD.COMPLEXITY' | translate }}
      </small>
    </div>
  </div>
}
